/**
 * API Endpoints Configuration
 * Use same-origin relative paths so calls work in vercel dev, Vite preview, and production.
 */

const API_BASE_PATH = '/api';

const joinApiPath = (path: string = ''): string => {
  if (!path) return API_BASE_PATH;
  return `${API_BASE_PATH}${path.startsWith('/') ? '' : '/'}${path}`;
};

// Endpoint paths (relative to origin)
export const API_BASE_URL = API_BASE_PATH;
export const AI_GENERATION_ENDPOINT = joinApiPath('ai/generate');
export const AI_EXPERT_GENERATION_ENDPOINT = joinApiPath('ai/generate-expert');
export const YOUTUBE_SEARCH_ENDPOINT = joinApiPath('youtube/search');
export const HEALTH_CHECK_ENDPOINT = joinApiPath('health');

// Helpers for services
export const getAIEndpoint = () => AI_GENERATION_ENDPOINT;
export const getExpertAIEndpoint = () => AI_EXPERT_GENERATION_ENDPOINT;
export const getYouTubeEndpoint = () => YOUTUBE_SEARCH_ENDPOINT;
export const getHealthEndpoint = () => HEALTH_CHECK_ENDPOINT;

console.log('📡 API Base:', API_BASE_URL);
